module.exports = __webpack_public_path__ + "626527026917f72770d6d5184dcf2679.png";